import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

const theme = createTheme({
  palette: {
    grey: {
      50: "#fafafa",
      200: "#ededed",
      300: "#e0e0e0",
      900: "#212121",
    },
    primary: {
      main: "#3f51b5",
    },
    common: {
      white: "#fff",
    },
  },
  spacing: (factor) => `${factor * 8}px`,
  typography: {
    pxToRem: (size) => `${size / 16}rem`,
  },
  shape: {
    borderRadius: "20px",
  },
  transitions: {
    create: (property) => `all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
  },
  breakpoints: {
    values: {
      lg: "1200px",
      md: "960px",
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/*" element={<App />} />
      </Routes>
    </ThemeProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
